import { translateFormsToFront,
    translateFormsToEnd } from "@classes/envelopes/forms.js"

import { getEnvelopeDocuments } from "@interfaces/envelopes/documents.js"
import { getEnvelopeFroms,
    createEnvelopeFroms,
    updateEnvelopeFroms,
    deleteEnvelopeFroms } from "@interfaces/envelopes/forms.js"

import { getParticipantEnvelopeFroms,
    createParticipantEnvelopeFroms,
    createNoappearanceParticipantEnvelopeFroms,
    updateParticipantEnvelopeFroms,
    deleteParticipantEnvelopeFroms,
    // checkDocumentsWithoutForm 
} from "@interfaces/envelopes/participants/forms.js"


class FormsManager{
    constructor(){
        this.newForms = []
        this.oldForms = []
        this.envelopeWsid = ""
        this.participantWsid = ""
        this.documents = []
    }

    getForms(){
        return this.newForms.filter(form => {
            if (form.type === "TEXT"
                || form.type === "DATE"
                || form.type === "SEAL"
                || form.type === "SIGN") return true
            return false
        })
    }

    getPagingSeals(){
        return this.newForms.filter(form => {
            if (form.type === "MULTI_CHECK_MARK") return true
            return false
        })
    }

    appendForm(form){
        this.newForms.push(form)
    }

    deleteForm(formRandom){
        let index = this.newForms.findIndex(form => form.random === formRandom)
        if (index > -1) this.newForms.splice(index, 1)
    }

    load(envelopeWsid, participantWsid){
        this.envelopeWsid = envelopeWsid
        this.participantWsid = participantWsid

        return this.loadFormsData(envelopeWsid, participantWsid)
    }

    noappearanceParticipantEnvelopeFroms(envelopeWsid, participantWsid, enableNoAppearance){
        this.envelopeWsid = envelopeWsid
        this.participantWsid = participantWsid
        return createNoappearanceParticipantEnvelopeFroms({
            envelopeWsid,
            participantWsid,
            enableNoAppearance
        }).then(_ => {}).catch(err => {
            console.error(err)
            return 
        })
    }

    loadFormsData(envelopeWsid, participantWsid){
        let docMap = {}

        return getEnvelopeDocuments({
            envelopeWsid
        }).then(res => {
            res.data.data.documents.forEach(doc => {
                docMap[doc.fileWsid] = true
                this.documents.push(doc)
            })
            return this.getFormsInterface().getEnvelopeFroms({
                envelopeWsid,
                participantWsid
            })
        }).then(res => {
            let forms = translateFormsToFront(res.data.data.forms)
            if (participantWsid) forms = forms.filter(form => form.participantWsid === participantWsid)
            
            this.newForms = forms.filter(form => docMap[form.docId])
            this.oldForms = translateFormsToFront(translateFormsToEnd(forms))
        })
    }
    //上传签署页面添加的日期、文本框、印章、签名元素的相关属性
    async uploadFormsData(){
        let oldforms = this.oldForms
        let forms = this.newForms

        let envelopeWsid = this.envelopeWsid
        let participantWsid = this.participantWsid

        let news = forms.filter(form => form.id === "")
        let exists = forms.filter(oldform => {
            return oldforms.find(form => form.id === oldform.id)
        })
        let deletes = oldforms.filter(oldform => {
            return !forms.find(form => form.id === oldform.id)
        })

        let updates = exists.filter(form => {
            let oldForm = oldforms.find(old => old.id === form.id)
            if (form.sameAs(oldForm)){
                return false
            }
            return true
        })

        console.log(news, updates, deletes)
        let createHandle = null
        if (news.length > 0){
            const forms = translateFormsToEnd(news)
            if (forms.some((form, index) => form.position.lrx > news[index].pageInfo?.width || form.position.lry > news[index].pageInfo?.height)) {
                return Promise.reject({
                    msg: "当前签署印章或签名位置数据有误，请刷新页面重新添加"
                })
            }
            createHandle = this.getFormsInterface().createEnvelopeFroms({
                envelopeWsid,
                participantWsid,
                forms
            }).then(res => {
                let forms = res.data.data.forms
                forms.forEach(newForm => {
                    let form = news.find(form => form.random == newForm.tagId)
                    form.id = newForm.formWsid
                    this.oldForms.push(...translateFormsToFront(translateFormsToEnd([form])))
                })
                console.log("添加表单成功")
            }).catch(err => {
                console.error(err)
                return
            })
        }

        let updateHandle = null
        if (updates.length > 0){
            const forms = translateFormsToEnd(updates)
            if (forms.some((form, index) => form.position.lrx > updates[index].pageInfo?.width || form.position.lry > updates[index].pageInfo?.height)) {
                return Promise.reject({
                    msg: "当前签署印章或签名位置数据有误，请刷新页面重新添加"
                })
            }
            updateHandle = this.getFormsInterface().updateEnvelopeFroms({
                envelopeWsid,
                participantWsid,
                forms
            }).then(res => {
                updates.forEach(form => {
                    let oldIndex = this.oldForms.findIndex(oldForm => form.id === oldForm.id)
                    this.oldForms.splice(oldIndex, 1, ...translateFormsToFront(translateFormsToEnd([form])))
                })
                console.log("修改表单成功")
            }).catch(err => {
                console.error(err)
                return
            })
        }

        let deleteHandle = null
        if (deletes.length > 0){
            deleteHandle = this.getFormsInterface().deleteEnvelopeFroms({
                envelopeWsid,
                participantWsid,
                forms: translateFormsToEnd(deletes).map(form => {
                    return {
                        formWsid: form.formWsid
                    }
                })
            }).then(res => {
                deletes.forEach(form => {
                    let oldIndex = this.oldForms.findIndex(oldForm => form.id === oldForm.id)
                    this.oldForms.splice(oldIndex, 1)
                })
                console.log("删除表单成功")
            }).catch(err => {
                console.error(err)
                return
            })
        }

        let res = await Promise.all([createHandle, updateHandle, deleteHandle])
        
        if (Object.prototype.toString.call(res) === "[object Array]"){
            // return checkDocumentsWithoutForm({
            //     envelopeWsid: this.envelopeWsid,
            //     participantWsid: this.participantWsid})
            let docWithOutForms = this.documents.filter(documents => {
                return !this.oldForms.find(oldForm => oldForm.docId == documents.fileWsid)
            }).map(docWithOutForm => {
                return docWithOutForm.fileName
            })
            return Promise.resolve(docWithOutForms) 
        } else {
            return Promise.reject(res)
        }
    }

    getFormsInterface(){
        if (this.participantWsid) {
            return {
                getEnvelopeFroms: getParticipantEnvelopeFroms,
                createEnvelopeFroms: createParticipantEnvelopeFroms,
                updateEnvelopeFroms: updateParticipantEnvelopeFroms,
                deleteEnvelopeFroms: deleteParticipantEnvelopeFroms
            }
        } else {
            return {
                getEnvelopeFroms: getEnvelopeFroms,
                createEnvelopeFroms: createEnvelopeFroms,
                updateEnvelopeFroms: updateEnvelopeFroms,
                deleteEnvelopeFroms: deleteEnvelopeFroms
            }
        }
    }

}

export {
    FormsManager
}